export default __webpack_public_path__ + "static/media/welcome.fca3ad12.png";